<template>
  <BaseIndex
    ref="baseIndex"
   :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="entryMovementItems"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
    :hasTableTitle="true"
    :hasDefaultPageTitle="false"
    tableTitle="Produtos Produzidos"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :executionOperation="executionOperation"
        :seedPlotOperation="seedPlotOperation"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :executionOperation="executionOperation"
        :seedPlotOperation="seedPlotOperation"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :executionOperation="executionOperation"
        :seedPlotOperation="seedPlotOperation"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      // tableHeaders: ,
      maskFields: [
        // { field: 'price', mask: 'currency_10d' },
        { field: 'quantity', mask: 'number' },
        { field: 'availableQuantity', mask: 'number' },
        // { field: 'totalPrice', mask: 'currency'}
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    entryMovementItems: {
      type: Array,
      default: () => []
    },
    executionOperation: Object,
    seedPlotOperation: Object,
    readOnly: {
      type: Boolean,
      default: false
    },   
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Produto Produzido"
    },
    modelNamePlural: {
      type: String,
      default: "Produtos Produzidos"
    },
  },
  created() {
    // console.log("form", this.entryMovementItems);
  },
  computed: {
    tableHeaders: function() {
      return [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        { text: "Estoque", align: "left", sortable: true, value: "storage.name" },
        { text: "Quantidade", align: "left", sortable: true, value: "quantity" },
        { text: "Und.", align: "left", sortable: true, value: "item.unit.name" },
        { text: "Ações", value: "action", sortable: false }
      ]
    }
  },
  methods: {
    entryUpdated: function(editedEntry){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(editedEntry){
      this.entryMovementItems.push(editedEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(editedEntry){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
  }
};
</script>

<style scoped></style>
